import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import userActions from 'actions/users'
import jobActions from 'actions/jobs'
import assetCategoryActions from 'actions/assetCategories'
import operatorActions from 'actions/operators'
import Component from 'components/Assets/ListView/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = {
  getLocationGroups: locationGroupActions.getItemsOffline,
  getLocations: locationActions.getItemsOffline,
  getUsers: userActions.getOptionsOffline,
  getJobs: jobActions.getOptions,
  getAssetCategories: assetCategoryActions.getItemsOffline,
  getOperators: operatorActions.getOptionsOffline,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
